import React, { useContext } from "react";
import { ThemeContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import MelilloLogo from "../../images/MelilloLogo.png";
import LanguageSelector from "./LanguageSelector";

const Brand = () => {
  const { dark } = useContext(ThemeContext);
  const { t } = useTranslation();

  return (
    <div className={`brand-wrapper ${dark ? "dark" : ""}`}>
      <img
        src={MelilloLogo}
        className="logo"
        alt={t("common.melilloLogoAlt")}
      />
      <LanguageSelector />
    </div>
  );
};

export default Brand;